import React from 'react';
import './gauge.css';

const Gauge = ({ 
  value, 
  max = 100, 
  size = 120, 
  strokeWidth = 8,
  color = 'primary',
  label,
  subtitle,
  showPercentage = true,
  animated = true
}) => {
  const percentage = Math.min((value / max) * 100, 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const getColor = () => {
    switch (color) {
      case 'success':
        return '#22C55E';
      case 'warning':
        return '#F59E0B';
      case 'danger':
        return '#EF4444';
      case 'accent':
        return '#8B5CF6';
      default:
        return '#6EE7F2';
    }
  };

  const getStatusColor = () => {
    if (percentage >= 90) return 'danger';
    if (percentage >= 70) return 'warning';
    return 'success';
  };

  return (
    <div className="jo-xyz-demo-gauge">
      <div className="jo-xyz-demo-gauge__container" style={{ width: size, height: size }}>
        <svg
          className="jo-xyz-demo-gauge__svg"
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          {/* Background circle */}
          <circle
            className="jo-xyz-demo-gauge__background"
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="var(--color-surface-light)"
            strokeWidth={strokeWidth}
            fill="none"
          />

          {/* Progress circle */}
          <circle
            className={`jo-xyz-demo-gauge__progress ${animated ? 'jo-xyz-demo-gauge__progress--animated' : ''}`}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={getColor()}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{
              '--target-offset': strokeDashoffset
            }}
          />
        </svg>

        {/* Center content */}
        <div className="jo-xyz-demo-gauge__content">
          {showPercentage ? (
            <div className="jo-xyz-demo-gauge__percentage">
              {Math.round(percentage)}%
            </div>
          ) : (
            <div className="jo-xyz-demo-gauge__value">
              {value}
            </div>
          )}
        </div>
      </div>

      {/* Labels */}
      <div className="jo-xyz-demo-gauge__labels">
        {label && (
          <div className="jo-xyz-demo-gauge__label">
            {label}
          </div>
        )}
        {subtitle && (
          <div className="jo-xyz-demo-gauge__subtitle">
            {subtitle}
          </div>
        )}
      </div>

      {/* Status indicator */}
      <div className={`jo-xyz-demo-gauge__status jo-xyz-demo-gauge__status--${getStatusColor()}`}>
        <div className="jo-xyz-demo-gauge__status-dot" />
        <span className="jo-xyz-demo-gauge__status-text">
          {percentage >= 90 ? 'High' : percentage >= 70 ? 'Medium' : 'Low'}
        </span>
      </div>
    </div>
  );
};

export default Gauge;
